import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

// These are used so that the MarkdownDocumentService can be injected in a way that allows for different implementations.
// The browser implementation will fetch markdown files via HTTP, while the server implementation will read them directly from the file system during prerendering.
// It prevents the server-side code from being included in the client-side bundle, which would cause errors due to the use of Node.js APIs that are not available in the browser.

export interface MarkdownDocumentReadRequest {
  markdownPath: string;
  serverFilePath?: string;
}

export interface MarkdownDocumentReader {
  readMarkdown(request: MarkdownDocumentReadRequest): Observable<string>;
}

export const MARKDOWN_DOCUMENT_READER =
  new InjectionToken<MarkdownDocumentReader>('MARKDOWN_DOCUMENT_READER');